/** Figma 5530-11030 / 5074-13248 — survey execution (question) full-page frame (1280 ref). */
export const SURVEY_EXEC_CONTENT_MAX_WIDTH_PX = 768
export const SURVEY_EXEC_SECTION_GAP_PX = 32
export const SURVEY_EXEC_PROGRESS_SECTION_GAP_PX = 12
/** Figma 5530-11031 — navy header band */
export const SURVEY_EXEC_HEADER_BAND_HEIGHT_PX = 285
/** Figma 5074-13253 — hero canvas offset from frame top */
export const SURVEY_EXEC_PAGE_TOP_PADDING_PX = 31
/** Figma 5074-13253 — padding inside hero canvas above title */
export const SURVEY_EXEC_HERO_INNER_PADDING_TOP_PX = 54
/** Figma 5074-13256 — title starts at y=31+54=85 inside 5074-13248 frame */
export const SURVEY_EXEC_HERO_CONTENT_PADDING_TOP_PX =
  SURVEY_EXEC_PAGE_TOP_PADDING_PX + SURVEY_EXEC_HERO_INNER_PADDING_TOP_PX
/** Figma 5530-11041 top=309 — gap between navy band end and progress section */
export const SURVEY_EXEC_WORKSPACE_TOP_GAP_PX = 24
/** Figma 5530-11050 — fixed question card shell height */
export const SURVEY_EXEC_QUESTION_CARD_MIN_HEIGHT_PX = 316

/** Figma 5074-13194 / 13268 — question card interior */
export const SURVEY_QUESTION_CARD_PADDING_X_PX = 52
export const SURVEY_QUESTION_CARD_PADDING_TOP_PX = 30
export const SURVEY_QUESTION_CARD_PADDING_BOTTOM_PX = 30
/** Eyebrow (y=30, h≈19.5) → prompt (y=63) */
export const SURVEY_QUESTION_EYEBROW_TO_PROMPT_GAP_PX = 13.5
/** Prompt block (y=63, h=60) → answer row (y=174) */
export const SURVEY_QUESTION_PROMPT_TO_ANSWERS_GAP_PX = 51
